<template>
  <div class="rootDom">
    <div class="titleGrid">
      <div class="close-btn" @click="hide('Close')">
        <i class="icon-popup-close"></i>
      </div>
    </div>

    <div class="content" :style="{ textAlign: textAlign}">{{msg}}</div>
    <div class="btnGrid">
      <div class="grayBtn" @click="hide('Cancel')">{{cancelText}}</div>
      <div class="buleBtn" @click="hide('Ok')">{{okText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    msg: {
      type: String,
      default: ''
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    } 
  },
  
  components: {},
  methods: {
    hide(type) {
      this.$emit("resultHandler", { type: type });
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
@import "./commonStyle";
.rootDom {
  position: relative;
  width: 540px;
  height: 234px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 4px;

  .titleGrid {
    position: absolute;
    width: 100%;
    position: relative;
    height: 40px;

    .close-btn {
      position: absolute;
      top: 14px;
      right: 17px;
      cursor: pointer;
    }
  }

  .content {
    position: absolute;
    top: 72px;
    width: 100%;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    padding: 0 60px;
  }
  .btnGrid {
    position: absolute;
    margin: 0 auto;
    top: 140px;
    width: 100%;
    padding: 0 87px;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/common.vue